import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'

export const getLegsProgressOutcomes = (
  historyCoupon: KambiHistoryCoupon | BetLoopKambiShareCoupon
): KambiHistoryCoupon['outcomes'] => {
  const couponRows = historyCoupon.couponRows.filter(({ index }) =>
    historyCoupon.bets[0].couponRowIndexes.includes(index)
  )

  return couponRows.flatMap(orderLegsStatusOutcomesByCouponRow(historyCoupon))
}

// =============
// Local Helpers
// =============

const orderLegsStatusOutcomesByCouponRow =
  (historyCoupon: KambiHistoryCoupon | BetLoopKambiShareCoupon) =>
  (couponRow: KambiHistoryCoupon['couponRows'][number]) => {
    if (couponRow.selectionType === 'BET_BUILDER' && couponRow.outcomeGroup) {
      const allOutcomeIds = couponRow.outcomeGroup.groups.flatMap(g => g.outcomeIds)
      const betBuilderOutcomes = historyCoupon.outcomes.filter(o =>
        allOutcomeIds.includes(o.outcomeId)
      )

      const firstNonWon = betBuilderOutcomes.find(o => o.status !== 'WON')
      if (firstNonWon) return [firstNonWon]

      const firstOutcomeId = couponRow.outcomeGroup.groups[0]?.outcomeIds[0]
      const firstOutcome = betBuilderOutcomes.find(o => o.outcomeId === firstOutcomeId)
      return firstOutcome ? [firstOutcome] : []
    }

    const outcome = historyCoupon.outcomes.find(o => o.outcomeId === couponRow.outcomeId)
    return outcome ? [outcome] : []
  }
